import React from 'react';
import styles from './TipCouponInfo.module.scss';

/* Assets */
import couponIcon from '../../../../../assets/icons/tips/coupon-info.png';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../../utils/translations/translator';

/* Providers */
import { useShopContext } from '../../../shared/__providers__/ShopContext';

/* Interfaces */
import { TipProduct } from '../../interfaces/TipProduct';

interface TipCouponInfoProps {}

export const TipCouponInfo: React.FC<TipCouponInfoProps> = () => {
  const { t } = useTranslation();
  const { shop } = useShopContext();

  const tip = shop!.selectedProduct as TipProduct;

  return (
    <>
      {tip && (
        <div className={styles.couponInfo}>
          <img
            src={couponIcon}
            alt="Coupon Icon"
            className={styles.couponIcon}
          />
          <div className={styles.textContainer}>
            <span className={styles.text}>
              {tr(t, 'if_tip_fails_youll_receive')}{' '}
            </span>
            <span className={styles.textHighlight}>{tr(t, 'ticket')} </span>
            <span className={styles.text}>
              {tr(t, 'to_unlock_another_tip_from')}{' '}
            </span>
            <span className={styles.tipsterName}>
              {tip.tipster.name}
              {'.'}
            </span>
          </div>
        </div>
      )}
    </>
  );
};
